import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';
import CustomImg, { CustomImgType } from '../CustomImage/CustomImg';
import './ButtonStyle.scss';

export interface ICustomIconButton extends IconButtonProps {
    imgSrc: string;
    imgClassName?: string;
    iconSize?: CustomImgType;
}

function CustomIconButton({
    imgSrc,
    imgClassName,
    iconSize = 'icon',
    ...props
}: ICustomIconButton): React.ReactElement {
    return (
        <IconButton {...props} data-testid={props.id}>
            <CustomImg
                imgType={iconSize}
                src={imgSrc}
                className={imgClassName}
                alt=""
            />
        </IconButton>
    );
}

export default CustomIconButton;
